import { useMutation } from '@tanstack/react-query';
import { useQueryClient } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { QuoteConversionPostRequestBody, QuoteConversionPostResponse } from '@lio/api-types';
import { indicationQueryKey } from './keys';

export const useIndicationConversion = (indicationId: string) => {
  const queryClient = useQueryClient();
  const client = useClient();
  const result = useMutation({
    mutationFn: (body: QuoteConversionPostRequestBody) =>
      client
        .post(`indication/${indicationId}/quote-conversion`, {
          json: {
            ...body,
          },
        })
        .json<QuoteConversionPostResponse>(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: indicationQueryKey.getWithParams({ indicationId }) });
    },
  });
  return { ...result, convertToQuote: result.mutateAsync };
};
